import { applyStatics, MenuItem } from '@szhsin/react-menu';
import { useContextMenuView } from '#/components/UnifiedRfqs/context-menu/context-menu';
import { useUMPlatformCreationDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import { isProductCodeDisabledForType } from '@paradigm/features/src/products/domain';

interface Props {
  datadogPrefix: string;
  onClick: () => void;
  type: 'OB' | 'RFQ';
}

export default function CreateMarketMenuItem({
  datadogPrefix,
  onClick,
  type,
  ...props
}: Props) {
  const { productCode } = useContextMenuView();
  const isPlatformCreationDisabled = useUMPlatformCreationDisabled();

  return (
    <MenuItem
      {...props}
      data-dd-action-name={`${datadogPrefix} Create ${type}`}
      onClick={onClick}
      disabled={
        isPlatformCreationDisabled ||
        isProductCodeDisabledForType(productCode, type)
      }
    >
      Create {type}
    </MenuItem>
  );
}
applyStatics(MenuItem)(CreateMarketMenuItem);
